import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20and%20lifestyle%20product%20collage%20on%20soft%20textured%20cream%20background%20with%20artistic%20arrangement%20of%20clothing%20accessories%20and%20shoes%2C%20clean%20editorial%20aesthetic%2C%20warm%20sand%20terracotta%20and%20olive%20green%20tones%2C%20sophisticated%20European%20design%2C%20soft%20diffused%20lighting%2C%20harmonious%20composition%20with%20generous%20negative%20space%2C%20high%20end%20lifestyle%20photography&width=1600&height=700&seq=hero-bg-v2-2026&orientation=landscape&nocache=true"
          alt="Itaobuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/30 via-background-50/15 to-background-50/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="flex-1">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              Itaobuy Spreadsheet
              <br />
              <span className="text-primary-500">Italia 2026</span>
            </h1>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-foreground-600 max-w-xl leading-relaxed">
              La guida italiana pi\u00f9 completa e aggiornata su Itaobuy Spreadsheet. Scopri come trovare i prodotti migliori, navigare tra le categorie e risparmiare tempo con la nostra piattaforma.
            </p>
            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/articolo-itaobuy-spreadsheet-guida"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Esplora le guide SEO
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 border-2 border-primary-500 text-primary-500 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy it now
                <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="w-full max-w-md">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20fashion%20product%20flatlay%20with%20elegant%20clothing%20and%20accessories%20arranged%20on%20textured%20linen%20surface%2C%20soft%20warm%20morning%20lighting%2C%20clean%20editorial%20style%2C%20terracotta%20cream%20and%20olive%20green%20tones%2C%20sophisticated%20European%20aesthetic%2C%20generous%20negative%20space%2C%20harmonious%20organic%20composition&width=600&height=400&seq=hero-collage-v2-01&orientation=landscape&nocache=true"
                alt="Itaobuy Spreadsheet product overview"
                className="w-full rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}